export default __webpack_public_path__ + "static/4-827ee221043f415203099333e65ef2aa.svg";